import { useEffect } from 'react';
import { useTheme } from '../theme/ThemeContext';
import {
  toastCloseClass,
  toastIconWrapClass,
  toastPanelClass,
  toastProgressBarClass,
  toastProgressTrackClass,
} from '../theme/themeStyles';

interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'info';
  onClose: () => void;
  duration?: number;
}

export default function Toast({ message, type, onClose, duration = 3000 }: ToastProps) {
  const { theme } = useTheme();

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const icon = {
    success: 'ri-checkbox-circle-line',
    error: 'ri-error-warning-line',
    info: 'ri-information-line',
  }[type];

  return (
    <div className="fixed top-4 right-4 z-[9999] animate-slide-in-right">
      <div className={toastPanelClass(theme, type)}>
        <div className={toastIconWrapClass(theme, type)}>
          <i className={`${icon} text-2xl`}></i>
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium leading-relaxed">{message}</p>
        </div>
        <button onClick={onClose} className={toastCloseClass(theme)}>
          <i className="ri-close-line text-xl"></i>
        </button>
      </div>

      <div className={toastProgressTrackClass(theme)}>
        <div
          className={toastProgressBarClass(theme)}
          style={{ animationDuration: `${duration}ms` }}
        ></div>
      </div>

      <style jsx>{`
        @keyframes slide-in-right {
          from {
            transform: translateX(400px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes shrink-width {
          from {
            width: 100%;
          }
          to {
            width: 0%;
          }
        }

        .animate-slide-in-right {
          animation: slide-in-right 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .animate-shrink-width {
          animation: shrink-width linear;
        }
      `}</style>
    </div>
  );
}
